import { cn, Icon } from '@bridebook/aura';
import { InfoCircle } from '@bridebook/aura/src/icons';
import { cva } from 'class-variance-authority';
import { ComponentProps } from 'react';

const tooltipInfoIconVariants = cva('', {
  variants: {
    variant: {
      dark: 'text-space',
      light: 'text-white',
    },
  },
});

type TooltipTriggerIconProps = Omit<ComponentProps<typeof Icon>, 'icon'> & {
  variant?: 'dark' | 'light';
};

export const TooltipInfoIcon = ({
  className,
  variant = 'dark',
  ...props
}: TooltipTriggerIconProps) => (
  <Icon
    icon={InfoCircle}
    size={16}
    className={cn(tooltipInfoIconVariants({ variant }), className)}
    {...props}
  />
);
